module.exports = __webpack_public_path__ + "static/img/danger.dab3ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/danger.png
// module id = uMi2
// module chunks = 1